// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-query li[data-v-b9caf788] {\n  margin: 0 10px;\n}\n.user-query li[data-v-b9caf788]:first-child {\n  margin-left: 0;\n}\n.text-input-query[data-v-b9caf788] {\n  height: 22px;\n  font-size: 0.75rem;\n  border-radius: 3px;\n  border-left: 1px solid #ccc;\n}\n.text-input-query[data-v-b9caf788]:focus {\n  border-left: 1px solid #2669a0;\n}", ""]);
// Exports
module.exports = exports;
